import React from 'react';

export default () => (
  <div className="About-Us">

    <div className="Heading">About Us</div>

    <div className="Content">

      <span className='Description'>
        Adenzo Comfies is Kenya's #1 Baby Shower Gift Shop &amp; one-stop-shop for all your Home Decor needs, Kids Toys &amp; Inflatable Air Beds, Chairs Bouncies &amp; Kiddy Pools. Checkout our collection of Quality Products and Special Offers or
      </span>

      <span className="Location">
        Visit us at Krishna Towers, Westlands, Woodvale Grove, <br/>Ground Floor (A10)
      </span>

    </div>

  </div>
)
